import { useLocation, useMatches, useNavigate } from 'react-router'
import './index.scss'
import { useEffect, useState } from 'react'
import { TextOutline, UserOutline } from 'antd-mobile-icons'

export const LayoutFooter = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const matches = useMatches()
  const [current, setCurrent] = useState('')

  useEffect(() => {
    if (matches.length > 0) {
      const match: any = matches[matches.length - 1]
      setCurrent(match?.handle?.code)
    }
  }, [location.pathname])

  const toHome = () => {
    navigate('/order')
  }

  const toUser = () => {
    navigate('/user')
  }

  const toAccept = () => {
    navigate('/accept')
  }

  return (
    <footer className="basiclayout-footer">
      <ul className="tabbar">
        <li className={current === 'order' ? 'tabbar-item active' : 'tabbar-item'} onClick={toHome}>
          <span style={{ textAlign: 'center' }}>
            <TextOutline fontSize={18} />
          </span>
          POP订单
        </li>
        <li className={current === 'accept' ? 'tabbar-item active' : 'tabbar-item'} onClick={toAccept}>
          <span style={{ textAlign: 'center' }}>
            <TextOutline fontSize={18} />
          </span>
          RT验收单
        </li>
        <li className={current === 'user' ? 'tabbar-item active' : 'tabbar-item'} onClick={toUser}>
          <span style={{ textAlign: 'center' }}>
            <UserOutline fontSize={18} />
          </span>
          我的
        </li>
      </ul>
    </footer>
  )
}
